import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaTrash, FaEdit } from "react-icons/fa";
import GlobalContext from "../connections/GlobalContext";
import engineGif from "../image/engine.gif";
import Head_data from "../components/Head_data";
import axios from "axios";
import { Modal, Label } from "flowbite-react";
import Select from "react-select";
import Button_submit from "../components/Button_submit";
import Swal from "sweetalert2";
import { Advance } from "./Advance";

const Complete_service = () => {
    const { state } = useLocation();
    const { globalValue } = useContext(GlobalContext);

    const [loading, setLoading] = useState(false);
    const [expandedLog, setExpandedLog] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState("");
    const [complete_records, setCompleteRecords] = useState([]);
    const [currentSpare, setCurrentSpare] = useState(null);
    const [currentServiceId, setCurrentServiceId] = useState(null);

    const [payment_type, setPayment_type] = useState("");
    const [payment_date, setPayment_date] = useState("");

    const [newSpare, setNewSpare] = useState({
        spare_id: null,
        spare_name: "",
        quantity: "",
        price: "",
        service_id: "",
        brand: "",
        model1: "",
    });
    const [spareOptions, setSpareOptions] = useState([]);

    const [showCustomFields, setShowCustomFields] = useState(false);
    const [customRate, setCustomRate] = useState("");
    const [customGST, setCustomGST] = useState("");
    const [customMPR, setCustomMPR] = useState("");
    const [customWarning, setCustomWarning] = useState(false);
    const [quantity_error, setQuantity_error] = useState("");
    const [priceError, setPriceError] = useState("");
    const [temp_estimate_id, setTemp_estimate_id] = useState("");
    const [is_edited, setIs_edited] = useState(false);
    const [view2, setView2] = useState(false);
    const [serviceId, setServiceId] = useState("");
    const [labour_charge, setLabour_charge] = useState("");
    const [services, setServices] = useState([]);

    const [serviceChargeModalOpen, setServiceChargeModalOpen] = useState(false);
    const [subCategoriesOptions, setSubCategoriesOptions] = useState([]);
    const [serviceChargeServiceId, setServiceChargeServiceId] = useState(null);
    const [serviceChargeList, setServiceChargeList] = useState([]);
    const [selectedSubCat, setSelectedSubCat] = useState(null);
    const [amountValue, setAmountValue] = useState("");
    const [editIndex, setEditIndex] = useState(null);
    const [serviceChargesByServiceId, setServiceChargesByServiceId] = useState({});
    const [insurance_amount, setInsurance_amount] = useState(0);


    useEffect(() => {
        if (
            complete_records &&
            complete_records.service_logs &&
            expandedLog !== null
        ) {
            const log = complete_records.service_logs.find(
                (item) => item.id === expandedLog
            );
            if (log && log.grouped_services) {
                log.grouped_services.forEach((group) => {
                    get_data(log.estimate_id, group.service_id);
                });
            }
        }
        setIns_amount(serviceData.grand_total);
    }, [expandedLog, complete_records]);


    const serviceData = complete_records;
    const photos = serviceData?.photos || [];
    const [ins_amount, setIns_amount] = useState(serviceData.grand_total);

    const service_complete_records = async (link) => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${globalValue}/get_service_details`,
                { link_id: link },
                { headers: { "x-access-token": sessionStorage.getItem("token") } }
            );
            setCompleteRecords(response.data.data);
        } catch (error) { }
        finally { setLoading(false); }
    };

    useEffect(() => {
        if (state?.link) service_complete_records(state.link); setIns_amount(serviceData.grand_total);

    }, [state?.link]);

    const [advance, setAdvance] = useState(0);

    useEffect(() => {
        if (serviceData?.customer?.advance_amount != null) {
            setAdvance(serviceData.customer.advance_amount);
        }
        setAdvance(serviceData?.customer?.advance_amount || 0);
    }, [serviceData, state?.link]);

    const fetchSpareOptions = async (service_id) => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${globalValue}/spareLog`,
                {
                    service: service_id,
                    estimate_id: complete_records?.estimate_id || "",
                    branch: sessionStorage.getItem("branch") || "",
                },
                { headers: { "x-access-token": sessionStorage.getItem("token") } }
            );
            setSpareOptions(response.data.map(spare => ({
                value: spare.spare_id,
                label: spare.spare_name,
                model: spare.model,
                quantity: spare.quantity,
            })));
        } catch (error) { }
        finally { setLoading(false); }
    };

    useEffect(() => {
        if (modalOpen && modalType !== "delete" && currentServiceId) fetchSpareOptions(currentServiceId);
    }, [modalOpen, modalType, currentServiceId]);

    const fetchServicesList = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${globalValue}/services`,
                {
                    params: { data: sessionStorage.getItem("branch") || "", position: "" },
                    headers: { "x-access-token": sessionStorage.getItem("token") },
                }
            );
            setServices(response.data);
        } catch (error) { }
        finally { setLoading(false); }
    };

    useEffect(() => { fetchServicesList(); }, [complete_records?.branch]);

    const openModal = (type, serviceId, spare = null) => {
        setModalType(type);
        setCurrentServiceId(serviceId);
        setCurrentSpare(spare);
        setModalOpen(true);
        setIs_edited(false);

        if (type === "add") {
            setNewSpare({
                spare_id: null, spare_name: "", quantity: "", price: "", service_id: serviceId, brand: "", model1: "",
            });
            setShowCustomFields(false);
            setCustomGST("");
            setCustomMPR("");
            setCustomRate("");
            setCustomWarning(false);
            setQuantity_error("");
        } else if (type === "edit" && spare) {
            setNewSpare({
                spare_id: spare.spare_id,
                spare_name: spare.spare_name,
                quantity: spare.quantity,
                price: spare.price.toString(),
                service_id: serviceId,
                brand: spare.brand,
                model1: spare.model1,
            });
            setShowCustomFields(false);
            setCustomGST("");
            setCustomMPR("");
            setCustomRate("");
            setCustomWarning(false);
            setQuantity_error(spare.quantity);
        }
    };

    const closeModal = () => {
        setIs_edited(false);
        setModalOpen(false);
        setCurrentSpare(null);
        setCurrentServiceId(null);
        setShowCustomFields(false);
        setCustomGST("");
        setCustomMPR("");
        setCustomRate("");
        setCustomWarning(false);
        setQuantity_error("");
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            let payload = {
                ...newSpare,
                service_id: currentServiceId,
                estimate_id: temp_estimate_id,
                is_manual_add: showCustomFields,
                branch: sessionStorage.getItem("branch"),
            };
            if (showCustomFields) {
                payload.gst = customGST;
                payload.mpr = customMPR;
                payload.rate = customRate;
            }

            let response;
            if (modalType === "add") {
                response = await axios.post(`${globalValue}/addServiceSpare`, payload, {
                    headers: { "x-access-token": sessionStorage.getItem("token") },
                });
            } else if (modalType === "edit") {
                response = await axios.post(
                    `${globalValue}/editServiceSpare`,
                    {
                        spare_id: currentSpare.spare_id,
                        quantity: newSpare.quantity,
                        price: newSpare.price,
                        service_id: currentServiceId,
                        estimate_id: temp_estimate_id,
                        is_edited: is_edited,
                    },
                    { headers: { "x-access-token": sessionStorage.getItem("token") } }
                );
            }
            console.log(response.data);

            if (response?.data?.error === "Insufficient quantity for this spare model") {
                Swal.fire({
                    title: "Insufficient Stock",
                    text: "Not enough stock available for the selected spare.",
                    icon: "warning",
                    confirmButtonText: "OK"
                });
                setLoading(false);
                return;
            } else {
                closeModal();
                service_complete_records(state.link);
            }
            service_complete_records(state.link);
        } catch (error) { }
        finally {
            setLoading(false); service_complete_records(state.link);
        }
    };

    const handleDelete = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${globalValue}/deleteServiceSpare`,
                {
                    spare_id: currentSpare.spare_id,
                    estimate_id: temp_estimate_id,
                    service_id: currentServiceId,
                    quantity: currentSpare?.quantity,
                },
                { headers: { "x-access-token": sessionStorage.getItem("token") } }
            );
            if (response.data === "success") {
                closeModal();
                service_complete_records(state.link);
            } else {
                closeModal();
            }
        } catch (error) { }
        finally { setLoading(false); }
    };

    const handleservice = async (est_id, service, labour_charge) => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${globalValue}/addServiceToEstimate`,
                { est_id, service, labour_charge },
                { headers: { "x-access-token": sessionStorage.getItem("token") } }
            );
            if (response.data === "success" || response.data === "failure") {
                setView2(false);
                service_complete_records(state.link);
                setIns_amount(serviceData.grand_total);
            }
        }
        finally { setLoading(false); }
    };

    const deleteService = async (estimate_id, service_id) => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${globalValue}/del_ser`,
                { estimate_id, service_id },
                { headers: { "x-access-token": sessionStorage.getItem("token") } }
            );
            if (response.data.message === "success") {
                service_complete_records(state.link);
            }
        } finally { setLoading(false); }
    };

    const fetchSubCategories = async (serviceId) => {
        try {
            const res = await axios.get(`${globalValue}/subcategories`, {
                params: { service_id: serviceId },
                headers: { "x-access-token": sessionStorage.getItem("token") },
            });
            if (res.data.success) {
                setSubCategoriesOptions(
                    res.data.subcategories.map((sc) => ({
                        value: sc.id,
                        label: sc.name,
                        amount: sc.amount,
                    }))
                );
            } else {
                setSubCategoriesOptions([]);
            }
        } catch {
            Swal.fire({ icon: "error", title: "Error!", text: "Could not fetch subcategories." });
        }
    };

    const get_data = async (estimate_id, service_id) => {
        try {
            const response = await axios.post(
                `${globalValue}/getServiceChargesForService`,
                { estimate_id, service_id },
                { headers: { "x-access-token": sessionStorage.getItem("token") } }
            );
            if (response.data) {
                setServiceChargeList(response.data.subcategories || []);
                setServiceChargesByServiceId((prev) => ({
                    ...prev,
                    [service_id]: response.data.subcategories || [],
                }));
            }
        } catch {
            Swal.fire({ icon: "error", title: "Error!", text: "Could not fetch service charges." });
        }
    };

    const openServiceChargesModal = (serviceId, estimateId) => {

        fetchSubCategories(serviceId); setServiceChargeServiceId(serviceId);
        setServiceChargeList([]);
        setTemp_estimate_id(estimateId);
        setSelectedSubCat(null);
        get_data(estimateId, serviceId);
        setAmountValue("");
        setEditIndex(null);
        setServiceChargeModalOpen(true);
    };

    const handleDeleteEntry = async (name, service_id, estimate_id) => {
        const confirmDelete = await Swal.fire({
            title: "Are you sure?",
            text: `Delete "${name}" from service charges?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (!confirmDelete.isConfirmed) return;

        const updatedList = (serviceChargesByServiceId[service_id] || []).filter(
            (item) => item.name.trim().toLowerCase() !== name.trim().toLowerCase()
        );
        console.log(updatedList, serviceChargesByServiceId[service_id], name);
        try {
            const payload = {
                estimate_id: estimate_id,
                service_id,
                subcategories: updatedList,
            };

            const response = await axios.post(
                `${globalValue}/addServiceCategory`,
                payload,
                { headers: { "x-access-token": sessionStorage.getItem("token") } }
            );

            if (response.data.success) {
                Swal.fire("Deleted!", `"${name}" has been removed.`, "success");
                get_data(estimate_id, service_id);
                service_complete_records(state.link);
                setServiceChargesByServiceId((prev) => ({
                    ...prev,
                    [service_id]: updatedList,
                }));
            } else {
                Swal.fire("Error", response.data.message || "Could not delete entry.", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Something went wrong while deleting!", "error");
        }
    };

    const saveServiceCharge = async () => {
        if (!selectedSubCat?.label) {
            Swal.fire("Select Sub Category", "", "warning");
            return;
        }
        if (!amountValue) {
            Swal.fire("Enter amount", "", "warning");
            return;
        }

        const nameToCheck = selectedSubCat.label.trim().toLowerCase();
        const isDuplicate = serviceChargeList.some((item, index) => (
            item.name.trim().toLowerCase() === nameToCheck && index !== editIndex
        ));

        if (isDuplicate) {
            Swal.fire("Duplicate Entry", "This sub category already exists.", "warning");
            return;
        }

        const newEntry = {
            id: selectedSubCat.value || null,
            name: selectedSubCat.label.trim(),
            amount: amountValue,
        };

        let updatedList = [...serviceChargeList];
        if (editIndex !== null) {
            updatedList[editIndex] = newEntry;
            setEditIndex(null);
        } else {
            updatedList.push(newEntry);
        }

        setServiceChargeList(updatedList);
        setSelectedSubCat(null);
        setAmountValue("");

        try {
            const payload = {
                estimate_id: temp_estimate_id,
                service_id: serviceChargeServiceId,
                subcategories: updatedList,
            };

            const response = await axios.post(
                `${globalValue}/addServiceCategory`,
                payload,
                { headers: { "x-access-token": sessionStorage.getItem("token") } }
            );

            if (response.data.success) {
                Swal.fire({ icon: "success", title: "Service charges saved successfully!" });
                get_data(temp_estimate_id, serviceChargeServiceId);
                setServiceChargeModalOpen(false);
                service_complete_records(state.link);
            } else {
                Swal.fire({ icon: "error", title: "Error!", text: response.data.message || "Could not save service charges." });
            }
        } catch {
            Swal.fire({ icon: "error", title: "Error!", text: "Could not save service charges." });
        }
    };

    const updateChargeField = (service_id, idx, field, value) => {
        setServiceChargesByServiceId((prev) => {
            const updated = [...(prev[service_id] || [])];
            updated[idx][field] = value;
            return { ...prev, [service_id]: updated };
        });
    };

    const saveChargesInline = async (service_id, estimate_id) => {
        try {
            const payload = {
                estimate_id: estimate_id,
                service_id,
                subcategories: serviceChargesByServiceId[service_id],
            };
            const response = await axios.post(
                `${globalValue}/addServiceCategory`,
                payload,
                { headers: { "x-access-token": sessionStorage.getItem("token") } }
            );
            if (response.data.success) {
                Swal.fire("Saved!", "Charges updated.", "success");
                get_data(estimate_id, service_id);
                service_complete_records(state.link);
                setIns_amount(serviceData.grand_total);

            } else {
                Swal.fire("Error", response.data.message, "error");
            }
        } catch {
            Swal.fire("Error", "Could not save charges.", "error");
        }
    };
    const navigate = useNavigate();
    const complete = async (
        id,
        link,
        customer_id,
        status,
        paymentType,
        paymentDate,
        grand_total,
        ins_amount
    ) => {
        if (!paymentType || !paymentDate) {
            Swal.fire({
                icon: "error",
                title: "Missing Details",
                text: "Payment Type and Payment Date are required before completing the service.",
            });
            return;
        }

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "Once completed, this action cannot be reversed!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, complete it!",
            cancelButtonText: "Cancel",
        });

        if (!result.isConfirmed) {
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(
                `${globalValue}/service_complete`,
                {
                    id,
                    link,
                    customer_id,
                    status,
                    paymentType,
                    paymentDate,
                    grand_total,
                    diff_amount: serviceData.grand_total - ins_amount,
                    ins_amount: ins_amount + (ins_amount * 0.18),
                    branch: sessionStorage.getItem("branch"),
                    advance
                },
                {
                    headers: {
                        "x-access-token": sessionStorage.getItem("token"),
                    },
                }
            );

            // ---------------------
            // ⭐ RESPONSE HANDLING
            // ---------------------

            // Case 1: SUCCESS
            if (response.data === "success") {
                Swal.fire({
                    icon: "success",
                    title: "Service Completed Successfully",
                });
                navigate('/service_log');
                return;
            }

            // Case 2: Pending estimates
            if (response.data === "pending") {
                Swal.fire({
                    icon: "warning",
                    title: "Pending Estimates",
                    text: "There are some pending estimates.",
                });
                return;
            }

            if (response.data?.success === 0) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: response.data.message || "Something went wrong!",
                });
                return;
            }

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Service completion failed. Please try again!",
            });

        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Network Error",
                text: "Unable to connect to server. Please try again!",
            });
        } finally {
            setLoading(false);
        }

    };



    useEffect(() => {
        if (!serviceData) setLoading(true);
        else setLoading(false);
    }, [serviceData]);

    return (
        <div className="md:ml-[250px] w-full md:w-[calc(100%-250px)] mt-20 h-[92vh] flex justify-center items-start px-2 md:px-6">
            {loading &&
                <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-70 z-50">
                    <img src={engineGif} alt="Loading..." className="w-24 h-24" />
                </div>
            }
            <div className="w-full h-[95%] bg-white px-6 py-6 rounded-xl shadow-lg overflow-auto">

                <div className="flex justify-between items-center mb-6">
                    <Head_data data=" Service Log Records" font="" size="3xl" />
                    <button
                        onClick={() => window.history.back()}
                        className="flex items-center gap-2 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md shadow"
                    >
                        <FaArrowLeft /> Back
                    </button>
                </div>

                <section className="bg-gray-100 border-l-4 rounded-lg p-4 mb-6 shadow-sm" style={{ borderColor: "#6b21a8" }}>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Customer Information</h3>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-2 text-gray-700 text-sm md:text-base">
                        <p><span className="font-medium">Name:</span> {serviceData?.customer?.customer_name}</p>
                        <p><span className="font-medium">Vehicle No:</span> {serviceData?.customer?.vehicle_no}</p>
                        <p><span className="font-medium">Brand:</span> {serviceData?.customer?.brand}</p>
                        <p><span className="font-medium">Model:</span> {serviceData?.customer?.model}</p>
                        <p><span className="font-medium">Engine No:</span> {serviceData?.customer?.engine_no}</p>
                    </div>
                </section>

                <section>
                    <h3 className="text-xl font-bold text-gray-800 mb-4"> Service Logs</h3>
                    {serviceData?.service_logs?.map((log) => (
                        <div key={log.id} className="bg-gray-50 border rounded-lg p-4 mb-6 shadow-sm hover:shadow-md transition">
                            <div className="flex flex-col md:flex-row justify-between border-b pb-3 mb-3">
                                <div>
                                    <h4 className="text-md md:text-lg font-bold text-gray-700">Estimate ID: {log.estimate_id}</h4>
                                    <p className="text-sm text-gray-500">Mode: <span className="capitalize">{log.mode}</span></p>
                                    <p className="text-sm text-gray-500">
                                        Date: {new Date(log.s_date).toLocaleDateString()} → {new Date(log.e_date).toLocaleDateString()}
                                    </p>
                                </div>
                                <div className="flex gap-3 mt-3 md:mt-0">
                                    <button
                                        className="h-12 px-2 py-1 bg-gray-200 text-sm rounded-md hover:bg-gray-300"
                                        onClick={() => setExpandedLog(expandedLog === log.id ? null : log.id)}
                                    >
                                        {expandedLog === log.id ? "Hide Details" : "View Details"}
                                    </button>
                                </div>
                            </div>


                            {expandedLog === log.id && (
                                <>
                                    <button
                                        onClick={() => { setView2(true); setTemp_estimate_id(log.estimate_id); }}
                                        className="px-3 py-1 mb-6 bg-green-100 hover:bg-green-200 text-green-700 text-sm rounded-md"
                                    >
                                        + Add Service
                                    </button>
                                    {log.grouped_services?.map((group, gIndex) => (
                                        <div key={gIndex} className="bg-white border rounded-md p-3 mb-4 shadow-sm">

                                            <div className="flex flex-wrap justify-between items-center border-b pb-2 mb-3">
                                                <h5 className="text-md font-semibold text-gray-800">Service: {group.service_name}</h5>
                                                <div className="flex gap-3">

                                                    <button
                                                        onClick={() => { openModal("add", group.service_id); setTemp_estimate_id(log.estimate_id); }}
                                                        className="px-3 py-1 bg-indigo-100 hover:bg-indigo-200 text-indigo-700 text-sm rounded-md"
                                                    >
                                                        + Add Spare
                                                    </button>
                                                    {/* <button
                                                        onClick={() => deleteService(log.estimate_id, group.service_id)}
                                                        className="px-3 py-1 bg-red-100 hover:bg-red-200 text-red-700 text-sm rounded-md"
                                                    >
                                                        <FaTrash />
                                                    </button> */}
                                                </div>
                                            </div>




                                            <div className="mt-2 flex justify-between items-center">
                                                <button
                                                    className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
                                                    onClick={() => openServiceChargesModal(group.service_id, log.estimate_id)}
                                                >
                                                    Add Service Charges
                                                </button>

                                            </div>

                                            <div className="mt-4">
                                                <h4 className="font-semibold mb-2">Service Charges</h4>
                                                {serviceChargesByServiceId[group.service_id] &&
                                                    serviceChargesByServiceId[group.service_id].length ? (
                                                    <div>
                                                        <table className="min-w-full border">
                                                            <thead>
                                                                <tr className="bg-gray-100">
                                                                    <th className="border p-2">Sub Category</th>
                                                                    <th className="border p-2">Amount</th>
                                                                    <th className="border p-2">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {serviceChargesByServiceId[group.service_id].map((charge, idx) => (
                                                                    <tr key={idx}>
                                                                        <td className="border p-2">
                                                                            <input
                                                                                type="text"
                                                                                value={charge.name}
                                                                                onChange={e =>
                                                                                    updateChargeField(group.service_id, idx, "name", e.target.value)
                                                                                }
                                                                                className="w-full border p-1"
                                                                            />
                                                                        </td>
                                                                        <td className="border p-2">
                                                                            <input
                                                                                type="number"
                                                                                value={charge.amount}
                                                                                onChange={e =>
                                                                                    updateChargeField(group.service_id, idx, "amount", e.target.value)
                                                                                }
                                                                                className="w-full border p-1"
                                                                            />
                                                                        </td>
                                                                        <td className="border p-2">
                                                                            <button
                                                                                className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                                                                                onClick={() => handleDeleteEntry(charge.name, group.service_id, log.estimate_id)}
                                                                            >
                                                                                Delete
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                        <button
                                                            className="mt-2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                                                            onClick={() => saveChargesInline(group.service_id, log.estimate_id)}
                                                        >
                                                            Save Charges
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <p className="text-gray-500 italic"></p>
                                                )}
                                            </div>


                                            {group.spares?.length > 0 && (
                                                <div className="mt-3">
                                                    <p className="text-sm font-medium text-gray-700 mb-2">Spares Used:</p>
                                                    <div className="overflow-x-auto">
                                                        <table className="w-full text-sm border">
                                                            <thead className="bg-gray-100 text-gray-600 font-medium">
                                                                <tr>
                                                                    <td className="px-3 py-2">Spare</td>
                                                                    <td className="px-3 py-2">Brand</td>
                                                                    <td className="px-3 py-2">Model</td>
                                                                    <td className="px-3 py-2">Qty</td>
                                                                    <td className="px-3 py-2">MRP</td>
                                                                    <td className="px-3 py-2">Estimated Price</td>
                                                                    <td className="px-3 py-2">Actions</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {group.spares.map((spare, spIndex) => (
                                                                    <tr key={spIndex} className="hover:bg-gray-50 text-gray-700">
                                                                        <td className="px-3 py-2">{spare.spare_name}</td>
                                                                        <td className="px-3 py-2">{spare.brand}</td>
                                                                        <td className="px-3 py-2">{spare.model1}</td>
                                                                        <td className="px-3 py-2">{spare.quantity}</td>
                                                                        <td className="px-3 py-2">₹{spare.mrp}</td>
                                                                        <td className="px-3 py-2">₹{Number(spare.price || 0).toFixed(2)}</td>
                                                                        <td className="px-3 py-2 flex gap-2">
                                                                            <button
                                                                                onClick={() => { openModal("edit", group.service_id, spare); setTemp_estimate_id(log.estimate_id); }}
                                                                                className="text-blue-600 hover:text-blue-800"
                                                                            >
                                                                                <FaEdit />
                                                                            </button>
                                                                            <button
                                                                                onClick={() => { openModal("delete", group.service_id, spare); setTemp_estimate_id(log.estimate_id); }}
                                                                                className="text-red-600 hover:text-red-800"
                                                                            >
                                                                                <FaTrash />
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    ))}

                    <div className="mt-4">
                        <h4 className="text-md font-semibold text-gray-700 mb-2">Estimate Images</h4>
                        {photos.length > 0 ? (
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                {photos.map((imageUrl, index) => (
                                    <div key={index} className="relative w-full">
                                        <img
                                            src={`${globalValue}/get_image/${imageUrl.trim()}`}
                                            alt={`Preview ${index + 1}`}
                                            className="w-full max-h-[300px] object-contain rounded-lg cursor-pointer border"
                                        />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="text-center text-gray-500">No images available</p>
                        )}
                    </div>

                    <div className="flex items-end space-x-4 bg-white p-6 mt-16 rounded-2xl shadow-md border w-full ">
                        <div className="flex flex-col w-40">
                            <label className="text-sm font-medium text-gray-700 mb-1">Accident Repair Charges RS.{ins_amount} with 18% ({(ins_amount * 0.18)}) = {((ins_amount * 0.18) + Number(ins_amount)).toFixed(2)} </label>
                            <input
                                type="number"
                                className="p-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                onChange={(e) => setIns_amount(e.target.value)}
                                value={ins_amount}
                            />
                        </div>
                        <div className="flex flex-col w-40">
                            <label className="text-sm font-medium text-gray-700 mb-1">Payment Type</label>
                            <select
                                className="p-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                onChange={(e) => setPayment_type(e.target.value)}
                                value={payment_type}
                            >
                                <option value="">Select</option>
                                <option value="cash">Cash</option>
                                <option value="credit">Credit</option>
                            </select>
                        </div>

                        <div className="flex flex-col w-44">
                            <label className="text-sm font-medium text-gray-700 mb-1">Completion Date</label>
                            <input
                                type="date"
                                className="p-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                onChange={(e) => setPayment_date(e.target.value)}
                                value={payment_date}
                            />
                        </div>

                        <div className="flex flex-col w-44">
                            <label className="text-sm font-medium text-gray-700 mb-1">Advance amount</label>
                            <input
                                type="number"
                                className="p-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                onChange={(e) => setAdvance(e.target.value)}
                                value={advance}
                            />
                        </div>

                        <div className="flex">
                            <button
                                onClick={() =>
                                    complete(
                                        serviceData?.service_logs[0]?.estimate_id,
                                        state.link,
                                        serviceData?.service_logs[0]?.customer_id,
                                        "2",
                                        payment_type,
                                        payment_date,
                                        0,
                                        Number(ins_amount),
                                    )
                                }
                                className="px-5 py-2 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-400 focus:outline-none transition"
                            >
                                Complete Service
                            </button>
                        </div>
                    </div>

                </section>
            </div>

            <Modal
                show={serviceChargeModalOpen}
                onClose={() => setServiceChargeModalOpen(false)}
                size="5xl"
            >
                <Modal.Header>Add Service Charges</Modal.Header>
                <Modal.Body>
                    <div className="space-y-4">
                        <div>
                            <Label value="Select / Add Sub Category" />
                            <Select
                                options={subCategoriesOptions}
                                value={selectedSubCat}
                                onChange={(opt) => {
                                    setSelectedSubCat(opt);
                                    if (opt?.amount) {
                                        setAmountValue(opt.amount);
                                    } else {
                                        setAmountValue("");
                                    }
                                }}
                                isClearable
                                isSearchable
                                placeholder="Select or type to add new"
                                onInputChange={(input, action) => {
                                    if (action.action === "input-change" && input) {
                                        setSelectedSubCat({ value: null, label: input });
                                        setAmountValue("");
                                    }
                                }}
                            />
                        </div>
                        <div>
                            <Label value="Amount" />
                            <input
                                type="number"
                                value={amountValue}
                                onChange={(e) => setAmountValue(e.target.value)}
                                className="mt-1 block w-full border border-gray-300 rounded p-2"
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                        onClick={saveServiceCharge}
                    >
                        Save
                    </button>
                    <button
                        className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                        onClick={() => setServiceChargeModalOpen(false)}
                    >
                        Cancel
                    </button>
                </Modal.Footer>
            </Modal>


            <Modal show={modalOpen} onClose={closeModal}>
                <Modal.Header>
                    {modalType === "add"
                        ? "Add Spare"
                        : modalType === "edit"
                            ? "Edit Spare"
                            : "Delete Spare"}
                </Modal.Header>
                <Modal.Body>
                    {modalType !== "delete" ? (
                        <>
                            {modalType === "add" && (
                                <div className="mb-4">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Spare Name
                                    </label>
                                    <Select
                                        options={spareOptions}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            menu: (base) => ({
                                                ...base,
                                                maxHeight: 130,
                                                overflowY: "auto",
                                                scrollbarWidth: "thin",
                                            }),
                                            menuList: (base) => ({
                                                ...base,
                                                maxHeight: 130,
                                                overflowY: "auto",
                                            }),
                                        }}
                                        maxMenuHeight={130}
                                        onChange={(selectedOption) => {
                                            const selectedSpare = selectedOption.model?.find(
                                                (spare) =>
                                                    (spare.brand === serviceData?.customer?.brand &&
                                                        spare.model === serviceData?.customer?.model) ||
                                                    (spare.brand === "common" && spare.model === "common")
                                            );

                                            const isCommonSpare =
                                                selectedSpare?.brand === "common" && selectedSpare?.model === "common";

                                            if (
                                                !selectedSpare ||
                                                selectedSpare.quantity === undefined ||
                                                selectedSpare.quantity === null
                                            ) {
                                                Swal.fire({
                                                    icon: "warning",
                                                    title: "No Spare Available",
                                                    text: `This spare is not available for ${serviceData?.customer?.brand} - ${serviceData?.customer?.model}.`,
                                                    confirmButtonColor: "#3085d6",
                                                });

                                                setNewSpare({
                                                    ...newSpare,
                                                    spare_id: selectedOption?.value || null,
                                                    spare_name: selectedOption?.label || "",
                                                    price: "",
                                                    service_id: currentServiceId,
                                                    brand: isCommonSpare ? "common" : serviceData?.customer?.brand,
                                                    model1: isCommonSpare ? "common" : serviceData?.customer?.model,
                                                });
                                                setQuantity_error(0);
                                                closeModal();
                                                return;
                                            } else {
                                                const calculatedPrice = parseFloat(selectedSpare.mrp);
                                                setNewSpare({
                                                    ...newSpare,
                                                    spare_id: selectedOption?.value || null,
                                                    spare_name: selectedOption?.label || "",
                                                    price: calculatedPrice.toFixed(2),
                                                    service_id: currentServiceId,
                                                    brand: isCommonSpare ? "common" : serviceData?.customer?.brand,
                                                    model1: isCommonSpare ? "common" : serviceData?.customer?.model,
                                                });
                                                setQuantity_error(selectedSpare.quantity);
                                                setCustomRate("");
                                                setCustomGST("");
                                                setCustomMPR("");
                                            }
                                        }}


                                        value={spareOptions.find(
                                            (option) => option.label === newSpare.spare_name
                                        )}
                                        placeholder="Select Spare Name"
                                        className="z-50"
                                    />
                                    {customWarning && (
                                        <p className="text-red-600 mt-1">
                                            Spare is not available for this vehicle. Please enter
                                            GST%, MRP and Rate manually.
                                        </p>
                                    )}
                                    {showCustomFields && (
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">
                                                    GST %
                                                </label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="0.01"
                                                    className="mt-1 p-2 w-full border rounded"
                                                    value={customGST}
                                                    onChange={(e) => setCustomGST(e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">
                                                    MRP
                                                </label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="0.01"
                                                    className="mt-1 p-2 w-full border rounded"
                                                    value={customMPR}
                                                    onChange={(e) => setCustomMPR(e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">
                                                    Rate
                                                </label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="0.01"
                                                    className="mt-1 p-2 w-full border rounded"
                                                    value={customRate}
                                                    onChange={(e) => {
                                                        const value = parseFloat(e.target.value);
                                                        setCustomRate(value);
                                                        if (value > customMPR) {
                                                            setPriceError("Rate cannot be higher than MRP");
                                                        } else {
                                                            setPriceError("");
                                                        }
                                                    }}
                                                />
                                                {priceError !== "" && (
                                                    <p className="text-red-600 mt-1"> {priceError}</p>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700">
                                    Quantity
                                </label>
                                <input
                                    type="number"
                                    min="0"
                                    className="mt-1 p-2 w-full border rounded"
                                    value={newSpare.quantity}
                                    onChange={(e) => {
                                        setNewSpare({
                                            ...newSpare,
                                            quantity: e.target.value,
                                            service_id: currentServiceId,
                                        })
                                        modalType === "edit" ? setIs_edited(true) : setIs_edited(false);
                                    }}
                                />
                            </div>
                            {!showCustomFields && <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700">
                                    Price
                                </label>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    className="mt-1 p-2 w-full border rounded"
                                    value={newSpare.price}
                                    onChange={(e) =>
                                        setNewSpare({ ...newSpare, price: e.target.value })
                                    }
                                />
                            </div>}
                        </>
                    ) : (
                        <div>
                            <p className="text-gray-700">
                                Are you sure you want to delete this spare?
                            </p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <div className="flex flex-col md:flex-row justify-between w-full gap-4">
                        <div className="flex gap-3">
                            <button
                                onClick={closeModal}
                                className="px-4 py-2 bg-gray-300 text-white rounded hover:bg-gray-400"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={modalType === "delete" ? handleDelete : handleSave}
                                disabled={
                                    modalType !== "delete" &&
                                    (!newSpare.quantity ||
                                        (!showCustomFields && !newSpare.price) ||
                                        newSpare.quantity < 1 ||
                                        (showCustomFields &&
                                            (!customGST || !customMPR || !customRate)) ||
                                        (modalType === "add" && !newSpare.spare_id))
                                }
                                className={`px-4 py-2 text-white rounded ${modalType === "delete"
                                    ? "bg-red-500 hover:bg-red-600"
                                    : "bg-blue-500 hover:bg-blue-600"
                                    } ${modalType !== "delete" &&
                                        (!newSpare.quantity ||
                                            (!showCustomFields && !newSpare.price) ||
                                            newSpare.quantity < 1 ||
                                            (showCustomFields &&
                                                (!customGST || !customMPR || !customRate)) ||
                                            (modalType === "add" && !newSpare.spare_id))
                                        ? "bg-gray-300 cursor-not-allowed"
                                        : ""
                                    }`}
                            >
                                {modalType === "delete" ? "Delete" : "Save"}
                            </button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={view2} size="4xl" onClose={() => setView2(false)}>
                <Modal.Header>Add Service</Modal.Header>
                <Modal.Body>
                    <form className="space-y-6">
                        <div>
                            <Label htmlFor="serviceId" value="Select Service" />
                            <select
                                id="serviceId"
                                name="serviceId"
                                value={serviceId}
                                onChange={(e) => {
                                    setServiceId(e.target.value);
                                    const selected = services.find(
                                        (s) => s[1] === e.target.value
                                    );
                                    if (selected) {
                                        setLabour_charge(selected[5]);
                                    } else {
                                        setLabour_charge("");
                                    }
                                }}
                                required
                                className="mt-1 block w-full px-3 py-2 rounded-md border border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="" disabled>
                                    Select service
                                </option>
                                {
                                    services.map(
                                        (service, index) =>
                                        (
                                            <option key={index} value={service[1]}>
                                                {service[2]}
                                            </option>
                                        )
                                    )
                                }
                            </select>
                            <Label htmlFor="service_amount" value="Labour Charge" />
                            <input
                                type="number"
                                className="mt-1 p-2 w-full border rounded"
                                value={labour_charge}
                                onChange={(e) => setLabour_charge(e.target.value)}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button_submit
                        onClick={() =>
                            handleservice(
                                // view_data.estimate_data.estimate_id,
                                temp_estimate_id,
                                serviceId,
                                labour_charge,
                            )
                        }
                        data="Add"
                        type="submit"
                        aditional="ms-auto"
                    />
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Complete_service;
